module.exports = __webpack_public_path__ + "img/R03_OFF.4c4ec807.jpg";